import { jsx as a, jsxs as m } from "react/jsx-runtime";
import { Skeleton as w, Box as D, Chip as b, MenuItem as y, ListSubheader as g, FormControl as E, InputLabel as P, Select as $ } from "@mui/material";
import { message as j } from "../../../queries/message/index.js";
import "../../../queries/contact/index.js";
import "../../../queries/calendars/index.js";
import "../../../index-DVHhaa_b.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
import { useAuth as M } from "../../../context/auth/index.js";
import { contacts as R } from "../../../types/contacts/index.js";
import F from "../../search/contactSearch/index.js";
import { useState as x, useEffect as K } from "react";
const de = ({ onChange: u, contactIds: s, disabled: c = !1 }) => {
  const { User: d } = M(), { data: o, isPending: I } = new j.parentContacts().ToQuery(), [h, f] = x([]), [k, L] = x(0), S = (d == null ? void 0 : d.PersonType) === R.PersonTypeEnum.Student;
  K(() => {
    if (!S || !o)
      return;
    if (s.length === 0) {
      f([]);
      return;
    }
    const e = [];
    o.forEach((t) => {
      const { Student: n, Teachers: p, Leaders: i } = t;
      e.push(n, ...p, ...i);
    });
    const r = s.map((t) => {
      const n = e.find((p) => p.ContactID === t);
      return n ? {
        id: n.ContactID,
        name: n.DisplaynameSurname
      } : null;
    }).filter((t) => t !== null);
    f(r);
  }, [S, o, s]);
  const N = (e) => {
    if (e && e.ID) {
      const r = Number(e.ID);
      if (!s.includes(r)) {
        const t = {
          id: r,
          name: e.label || `${e.Firstname} ${e.Surname}`
        };
        f([...h, t]), u([...s, r]), L((n) => n + 1);
      }
    }
  }, T = (e) => {
    f(h.filter((r) => r.id !== e)), u(s.filter((r) => r !== e));
  }, v = (e) => {
    const {
      target: { value: r }
    } = e;
    r || u([]), u(typeof r == "object" ? r.map((t) => Number(t)) : typeof r == "string" ? r.split(",").map((t) => Number(t)) : [Number(r)]);
  };
  if (I)
    return /* @__PURE__ */ a(w, { variant: "rounded", width: 200, height: 40 });
  if (S)
    return /* @__PURE__ */ m(D, { children: [
      !c && /* @__PURE__ */ a(
        F,
        {
          lookupType: "messagerecipients",
          placeholder: "Search for recipients...",
          onSelect: N
        },
        k
      ),
      h.length > 0 && /* @__PURE__ */ a(D, { sx: { display: "flex", flexWrap: "wrap", gap: 0.5, mt: c ? 0 : 1 }, children: h.map((e) => /* @__PURE__ */ a(
        b,
        {
          label: e.name,
          onDelete: c ? void 0 : () => T(e.id)
        },
        e.id
      )) })
    ] });
  const l = [];
  o != null && o.some((e) => e.CanMessageStudent) && l.push(/* @__PURE__ */ a(g, { children: "Students" }));
  let C = [];
  return o == null || o.forEach((e) => {
    const { CanMessageStudent: r, Student: t, Teachers: n, Leaders: p } = e;
    C = [...C, t, ...n, ...p], r && l.push(/* @__PURE__ */ a(y, { value: t.ContactID.toString(), "aria-label": t.DisplaynameSurname, children: t.DisplaynameSurname }, t.ContactID)), n.length > 0 && (l.push(/* @__PURE__ */ m(g, { children: [
      t.Displayname,
      "'s Teachers"
    ] }, `${t.ContactID} teachers`)), l.push(n.map((i) => /* @__PURE__ */ m(y, { value: i.ContactID.toString(), "aria-label": i.DisplaynameSurname, children: [
      i.DisplaynameSurname,
      " ",
      i.ClassName
    ] }, i.ContactID)))), p.length > 0 && (l.push(/* @__PURE__ */ m(g, { children: [
      t.Displayname,
      "'s Leaders"
    ] }, `${t.ContactID} leaders`)), l.push(p.map((i) => /* @__PURE__ */ m(y, { value: i.ContactID.toString(), "aria-label": i.DisplaynameSurname, children: [
      i.DisplaynameSurname,
      " ",
      i.ClassName
    ] }, i.ContactID))));
  }), /* @__PURE__ */ m(E, { children: [
    /* @__PURE__ */ a(P, { id: "recipient-picker", children: "Recipients" }),
    /* @__PURE__ */ a(
      $,
      {
        label: "Recipients",
        labelId: "recipient-picker",
        multiple: !0,
        disabled: c,
        value: s.map((e) => e.toString()),
        onChange: v,
        renderValue: (e) => /* @__PURE__ */ a(D, { sx: { display: "flex", flexWrap: "wrap", gap: 0.5 }, children: e.map((r) => {
          var n;
          let t = (n = C.find((p) => p.ContactID === Number(r))) == null ? void 0 : n.DisplaynameSurname;
          return /* @__PURE__ */ a(b, { label: t }, r);
        }) }),
        children: l
      }
    )
  ] });
};
export {
  de as RecipientPicker
};
//# sourceMappingURL=RecipientPicker.js.map
